import { useState } from "react";
import { toast } from "sonner";
import { Logo } from "@/components/marketing/SiteNav";
import { Input } from "@/components/ui/input";
import { useAuth } from "@/context/AuthContext";
import { api, errMsg } from "@/lib/api";
import { Btn } from "./bits";

export function NoOrg() {
  const { me, refresh, logout } = useAuth();
  const [name, setName] = useState("");
  const create = async () => {
    try { await api.post("/orgs", { name }); await refresh(); toast.success("Organisation created"); } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <div className="min-h-screen grid-bg flex items-center justify-center px-5">
      <div className="panel max-w-md w-full p-8 space-y-5" data-testid="no-org-card">
        <Logo />
        <h1 className="text-2xl font-bold text-slate-50">Your account isn't linked to an organisation yet</h1>
        <p className="text-sm text-slate-400">Signed in as {me.email}. Ask your organisation's Admin to invite this email address, then sign in again.</p>
        {me.is_owner && (
          <div className="space-y-2 pt-2 border-t border-[#1E2D4A]">
            <p className="font-mono text-xs text-slate-500 uppercase">Create organisation (platform owner)</p>
            <Input value={name} onChange={(e) => setName(e.target.value)} placeholder="Organisation name" data-testid="new-org-name-input" />
            <Btn onClick={create} disabled={!name.trim()} data-testid="create-org-btn">Create</Btn>
          </div>
        )}
        <Btn variant="ghost" onClick={logout} data-testid="no-org-logout-btn">Sign out</Btn>
      </div>
    </div>
  );
}
